import * as React from "react";
import { Box, Typography } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import { platformFonts } from "../tickitPlatformTheme";
import PlatformButton from "./PlatformButton";

export default function PlatformEmptyState({
  icon: Icon = InboxOutlinedIcon,
  title = "No results",
  description,
  actionLabel,
  onAction,
  sx = {},
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        py: 6,
        px: 2,
        ...sx,
      }}
    >
      <Icon sx={{ fontSize: 48, color: "var(--platform-text-3)", mb: 1.5, opacity: 0.55 }} />
      <Typography
        sx={{
          fontFamily: platformFonts.display,
          fontWeight: 700,
          fontSize: "1rem",
          color: "var(--platform-text)",
          mb: 0.5,
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          sx={{
            fontFamily: platformFonts.body,
            fontSize: "13.5px",
            color: "var(--platform-text-3)",
            maxWidth: 360,
            mb: actionLabel ? 2 : 0,
          }}
        >
          {description}
        </Typography>
      )}
      {actionLabel && onAction && (
        <PlatformButton variant="primary" size="small" onClick={onAction}>
          {actionLabel}
        </PlatformButton>
      )}
    </Box>
  );
}
